import React, { useState, useEffect } from 'react';
import {
    Grid,
    Box,
    ListItemText,
    ListItemButton,
    CircularProgress,
    Typography,
    Tooltip
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import TimeAgo from 'react-timeago';
import AppConstants from '../../../App/AppConstants';
import { secondsToDigitalText } from '../../../utilities/timeUtilities';
import VideosPageConstants from '../VideosPage/VideosPageConstants';
import DeleteIcon from '@mui/icons-material/DeleteForeverRounded';
import { executeCarefully } from '../../../utilities/basicUtilities';
import ConfirmationDialog from '../../dialogs/ConfirmationDialog';
import CircleProgressIconButton from '../../buttons/CircleProgressIconButton';
import { ExportVideoTypes } from '../../../constants/ExportVideoTypes';

const styles = (theme) => ({
    freeTag: {
        color: theme.palette.exportTag.free
    },
    testTag: {
        color: theme.palette.exportTag.test
    },
    primary : {
        fontSize: "14.5px"
    },
    secondary: {
        fontSize: "14.5px"
    }
});

const SelectableExportListItem = (props) => {
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
    const [status, setStatus] = useState(null);
    const [isDeleteButtonVisible, setIsDeleteButtonVisible] = useState(false);
    const { classes, videoExportData, onSelect, isSelected, isDisabled, onDelete } = props;

    useEffect(() => {
        if (status !== videoExportData.status) {
            setStatus(videoExportData.status);
        }
    }, [videoExportData.status])

    const onItemClick = () => {
        executeCarefully(onSelect, videoExportData);
    };

    return (
        <Box onMouseOver={() => setIsDeleteButtonVisible(true)} onMouseLeave={() => setIsDeleteButtonVisible(false)}>
            <ListItemButton onMouseOver={() => setIsDeleteButtonVisible(true)} onMouseLeave={() => setIsDeleteButtonVisible(false)} onClick={onItemClick} selected={isSelected} button disabled={isDisabled}>
                <ListItemText
                    classes={{ secondary: classes.secondary }}
                    primary={
                        status === VideosPageConstants.FAILED_EXPORT_STATUS ?
                            <Typography className={classes.primary} variant='subtitle2'>
                                FAILED
                            </Typography>
                            :
                            <Typography className={classes.primary} variant='subtitle2'>
                                {videoExportData.type === AppConstants.FREE_SUBSCRIPTION_TYPE &&
                                    <span className={classes.freeTag}>FREE </span>
                                }
                                {videoExportData.type === ExportVideoTypes.TEST_VIDEO &&
                                    <span className={classes.testTag}>TEST </span>
                                }
                                {`${videoExportData.resolution}p ${videoExportData.fps} FPS`}
                            </Typography>
                    }
                    secondary={
                        videoExportData.videoFileCreatedTime ?
                            <span>Created <TimeAgo date={videoExportData.videoFileCreatedTime} title={new Date(videoExportData.videoFileCreatedTime).toString()} /></span>
                            :
                            <span>Started <TimeAgo date={videoExportData.exportCreatedTime} title={new Date(videoExportData.exportCreatedTime).toString()} /></span>
                    }
                />
                <Box>
                    <Grid container spacing={1} justifyContent='center' alignItems='center'>
                        {status === VideosPageConstants.RUNNING_EXPORT_STATUS && !isDeleteButtonVisible &&
                            <Grid>
                                <CircularProgress />
                            </Grid>
                        }
                        {status === VideosPageConstants.COMPLETED_EXPORT_STATUS &&
                            <Grid>
                                <Typography variant='body2'>
                                    {secondsToDigitalText(videoExportData.duration)}
                                </Typography>
                            </Grid>
                        }
                        {(status === VideosPageConstants.COMPLETED_EXPORT_STATUS || status === VideosPageConstants.PENDING_EXPORT_STATUS || isDeleteButtonVisible) &&
                            <Grid>
                                <Tooltip title='Delete Export' placement='top' arrow>
                                    <Box>
                                        <CircleProgressIconButton aria-label='Delete Export'
                                            loading={videoExportData.isDeleting}
                                            disabled={videoExportData.isDeleting || isDisabled}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                setIsDeleteConfirmationOpen(true);
                                            }}
                                        >
                                            <DeleteIcon />
                                        </CircleProgressIconButton>
                                    </Box>
                                </Tooltip>

                                <ConfirmationDialog
                                    title={'Delete Export?'}
                                    open={isDeleteConfirmationOpen}
                                    onClose={() => setIsDeleteConfirmationOpen(false)}
                                    confirmation={() => onDelete(videoExportData)}
                                    storageKey='SKIP_DELETE_EXPORT_CONFIRMATION'
                                    okText='Delete'
                                    alertColor showCheck
                                >
                                    <Grid>
                                        <Typography>
                                            Are you sure you want to delete this export? The video file cannot be recovered later.
                                        </Typography>
                                    </Grid>
                                </ConfirmationDialog>
                            </Grid>
                        }
                    </Grid>
                </Box>
            </ListItemButton>
        </Box>
    );
}

export default withStyles(SelectableExportListItem, styles);